import { SignUpDto } from '../../../../services/dtos/signUpDto';
import { useState } from 'react';
import { signUp } from '../../../../services/userService';
import { useSnackbar } from 'notistack';
import { useRouter } from 'next/router';
import { routes } from '../../../../config/routes';
import { useTranslation } from 'next-i18next';
import { useTurnstile } from 'react-turnstile';

export const useSignUpForm = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const turnstile = useTurnstile();

  const onSuccess = async (data: SignUpDto) => {
    try {
      setLoading(true);

      await signUp(data);

      router.replace({
        pathname: routes.EMAIL_CONFIRMATION,
        query: {
          firstName: data.firstName,
        },
      });
    } catch (e) {
      turnstile.reset();

      if (e?.response?.data?.message === 'email in use') {
        enqueueSnackbar(t('auth:signUp:emailInUse'), { variant: 'error' });
      } else {
        enqueueSnackbar(enqueueSnackbar(t('auth:signUp:error')), {
          variant: 'error',
        });
      }

      // TODO: report to sentry
    }

    setLoading(false);
  };

  return { onSuccess, loading };
};
